/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';

import { Theme as MaterialTheme, useTheme, Grid, Paper } from "@mui/material";
import { useState, useEffect, Dispatch, SetStateAction, } from "react";

import { useAppBarHeight, useDebounce } from '../../../common/CustomHooks';
import { useTranslation } from 'react-i18next';
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from 'react-router-dom';
import DatagridPendingWork from '../components/DatagridPendingWork';

const DashboardPendingWorkRoute = (): JSX.Element => {

    const { organizationId } = useParams();

    const theme = useTheme();

    const { t, i18n } = useTranslation();

    //##########################################################################################################

    // Dette er en midlertidig kommentar.

    //###############################################################################################################################################
    //###############################################################################################################################################
    //########################################################API Calls and useEffects###############################################################
    useEffect(() => {
        let isMounted = true; //Avoid memory leaks. Async function running after dismount.
        //const service = new SourceDocumentService();

        const getData = async () => {

        };
        //Close current window when searching for something new
        getData();

        return () => { isMounted = false };
    }, []);

    //###############################################################################################################################################
    //###############################################################################################################################################
    
    //###############################################################################################################################################
    //###############################################################################################################################################
    const appBarHeight = useAppBarHeight();
    //########################################################################################
    //########################################################################################
    return <main>
        <Grid container component={Paper} direction="column" wrap="nowrap"
            sx={{
                paddingTop: theme.spacing(2),
                width: "100%",
                height: {
                    xs: "calc(100vh - " + appBarHeight + "px )",
                    xl: "calc(100vh)"
                },
                //"& .MuiDataGrid-columnHeaders": { backgroundColor: theme.palette.info.main, color: "white" },
                //"& .MuiDataGrid-footerContainer": { backgroundColor: theme.palette.info.main, color: "white" }
            }}>
            <DatagridPendingWork/>
        </Grid>
    </main>

}
export default DashboardPendingWorkRoute;